export * from './useProductDetailsContentNavigation';
